module.exports = {
	blue: '#1f83ef',
	cyan: '#24bfdf',
	green: '#73a535',
	grey: 'rgb(201, 203, 207)',
	orange: '#f57c20',
	purple: '#914ecf',
	red: '#d43f3a',
	yellow: '#fdb813'
};



// WEBPACK FOOTER //
// ./frontend/shared/js/lib/chartColors.js